// extracted by mini-css-extract-plugin
module.exports = {"container":"_3k3x4","headline":"_2EpBe","border":"_1UiTM","sena-stories":"_3ZAAc"};